// extracted by mini-css-extract-plugin
export var container = "_1r-0";
export var disabled = "_1r-4";
export var fullWidth = "_1r-3";
export var lined = "_1r-1";
export var selected = "_1r-5";
export var tab = "_1r-2";